import React, { useState, Button, useEffect } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";

import {
  alertsActions,
  priceTariffsActions,
  checkInPeriodsActions,
  productsSelectors,
  useSelector,
} from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils"; // necessary to communicate with inbooma-react
import { _, $, moment } from "../../../../../vendor";
import PricesList from "./PricesList";
import de from "date-fns/locale/de";
import DatePicker from "react-datepicker";
import Select from "react-select";
import FormItem from "../../../components/FormItem";
import pricetariffs from "../../../../collections/Pricetariffs";

const SubItemView = (props) => {
  const [initialized, setInitializeState] = useState(false);
  const [itemState, setItemState] = useState("init"); // init, saving
  const [pricetariffPending, setPricetariffPending] = useState(false);
  const _pricetariffs = useSelector((state) => state.price_tariffs_data);
  const _editCheckInPeriod = useSelector((state) => state.check_in_periods_data.editCheckInPeriod);
  console.log(props.pricetariffValidFrom);
  const [pricetariffValidFrom, setValidFrom] = useState(
    typeof props.pricetariffValidFrom.id === "undefined"
      ? {
          prices: [],
          pricesToPush: [],
          valid_from: moment().format('YYYY-MM-DD HH:mm:00'),
          pricetariff_id: null,
        }
      : props.pricetariffValidFrom
  );
  let HelpPrices = null;

  // initialize pricetariff - set selected pricetariff or set defaults
  const [pricetariff, setPricetariff] = useState(
    typeof props.pricetariff.id === "undefined"
      ? {
          productsForSelect: [],
          products: [],
          client_id: Number(Biscuit.get("user.client_id")),
          description: "",
          name: "",
          duration: "",
          _rate: 60,
          _amount: "",
          extension: "donothing",
          extension_possible: "WithoutTaskAndPayment",
          default_tariff: false,
          pricetariff_valid_froms: [],
          check_in_periods: [],
          check_in_periods_to_save: [],
          short_description: "",
          only_discount_first_unit: false,
          types: "booking",
          amount_cost_free_contingents: null,
          payment_methods: null,
        }
      : props.pricetariff
  );

  const [timespan, setTimespan] = useState({
    begin_date: new Date(moment(pricetariffValidFrom.valid_from).format("YYYY-MM-DD HH:mm")),
  });
  let language = Biscuit.get("user.lang").replace("-", "_");

  const [prices, setPrices] = useState(null);
  const _openingPeriods = useSelector((state) => state.check_in_periods_data.getCheckInPeriods);
  const _editPricetariff = useSelector((state) => state.price_tariffs_data.patchPricetariff);
  const _addPricetariff = useSelector((state) => state.price_tariffs_data.postPricetariff);
  const [availProducts, setAvailProducts] = useState({ products: [] });
  const [pricetariffChanged, setPricetariffChanged] = useState(false);
  const [contingentProduct, setContingentProduct] = useState(false);
  const [contingentProducts, setContingentProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [openingPeriodsPending, setOpeningPeriodsPending] = useState(false);
  const [openingPeriodsSelects, setOpeningPeriodsSelects] = useState([]);
  const [selectedOpeningPeriods, setSelectedOpeningPeriods] = useState([]);
  const [notification, setNotification] = useState({
    message: "",
    show: false,
  });

  useEffect(() => {
    if (_openingPeriods.success === "" || !openingPeriodsPending) {
      return;
    }
    if (_openingPeriods.success === true) {
      console.log("_openingPeriods success", _openingPeriods.data);
      getSelectItemsForOpeningPeriods(_openingPeriods.data);
    }
    setOpeningPeriodsPending(false);
  }, [_openingPeriods]);

  /*useEffect(() => {
    if (_pricetariffs.pricetariffs.success === "") {
      // true or false no matter if a new item is created or an existing item modified
      return;
    }

    if (itemState !== "saving") return;

    var isNewItem = document.location.href.indexOf("add") >= 0;

    if (isNewItem) {
      if (_pricetariffs.pricetariffs.success === true) {
        props.showNotification(
          "success",
          _pricetariffs.pricetariffs.data[_pricetariffs.pricetariffs.data.length - 1].id
        );
      }

      if (_pricetariffs.pricetariffs.success === false) {
        props.showNotification("warning", 0);
      }
    } else {
      if (_pricetariffs.pricetariffs.success === true) {
        props.showNotification("success", props.pricetariff.id);
      }

      if (_pricetariffs.pricetariffs.success === false) {
        props.showNotification("warning", props.pricetariff.id);
      }
    }

    // close window
    abortButtonRef.current.click();
  }, [_pricetariffs]);*/

  useEffect(() => {
    if(_editPricetariff.success === "" || !pricetariffPending){
      return;
    }
    if(_editPricetariff.success === true){
      abortButtonRef.current.click();
      props.showNotification("success", props.pricetariff.name, null, 'pricetariff');
    } else {
      props.showNotification("warning", props.pricetariff.name,  null, 'pricetariff');
    }
    setPricetariffPending(false);
  }, [_editPricetariff]);

  useEffect(() => {
    if(_addPricetariff.success === "" || !pricetariffPending){
      return;
    }
    if(_addPricetariff.success === true){
      abortButtonRef.current.click();
      props.showNotification("success", _addPricetariff.data.name, null, 'pricetariff');
    } else {
      props.showNotification("warning", pricetariff.name, null, 'pricetariff');
    }
    setPricetariffPending(false);
  }, [_addPricetariff]);

  useEffect(() => {
    setTimespan({
      begin_date: new Date(moment(pricetariffValidFrom.valid_from).format("YYYY-MM-DD HH:mm")),
    });
  },[pricetariffValidFrom]);
  const getSelectItemsForOpeningPeriods = (data) => {
    let objects = [];
    if (data.length) {
      const day = {
        1: "monday",
        2: "tuesday",
        3: "wednesday",
        4: "thursday",
        5: "friday",
        6: "saturday",
        7: "sunday",
      };
      data.map((oP) => {
        let newObj = {};
        newObj["id"] = oP.id;
        if (oP.check_in_hours.length > 0) {
          let same = [],
            secondSame = [],
            thirdSame = [],
            fourthSame = [],
            fifthSame = [],
            sixthSame = [],
            seventhSame = [];
          oP.check_in_hours.map((cP) => {
            if (same.length < 1) {
              same.push(cP);
            } else {
              if (same[0].begin === cP.begin && same[0].end === cP.end) {
                same.push(cP);
              } else {
                if (secondSame.length < 1) {
                  secondSame.push(cP);
                } else {
                  if (secondSame[0].begin === cP.begin && secondSame[0].end === cP.end) {
                    secondSame.push(cP);
                  } else {
                    if (thirdSame.length < 1) {
                      thirdSame.push(cP);
                    } else {
                      if (thirdSame[0].begin === cP.begin && thirdSame[0].end === cP.end) {
                        thirdSame.push(cP);
                      } else {
                        if (fourthSame.length < 1) {
                          fourthSame.push(cP);
                        } else {
                          if (fourthSame[0].begin === cP.begin && fourthSame[0].end === cP.end) {
                            fourthSame.push(cP);
                          } else {
                            if (fifthSame.length < 1) {
                              fifthSame.push(cP);
                            } else {
                              if (fifthSame[0].begin === cP.begin && fifthSame[0].end === cP.end) {
                                fifthSame.push(cP);
                              } else {
                                if (sixthSame.length < 1) {
                                  sixthSame.push(cP);
                                } else {
                                  if (
                                    sixthSame[0].begin === cP.begin &&
                                    sixthSame[0].end === cP.end
                                  ) {
                                    sixthSame.push(cP);
                                  } else {
                                    if (seventhSame.length < 1) {
                                      seventhSame.push(cP);
                                    } else {
                                      if (
                                        seventhSame[0].begin === cP.begin &&
                                        seventhSame[0].end === cP.end
                                      ) {
                                        seventhSame.push(cP);
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          });
          let mode = "oneString";
          if (seventhSame.length > 0) {
            mode = "everySingleDay";
          } else if (sixthSame.length > 0) {
            mode = "sixDays";
          } else if (fifthSame.length > 0) {
            mode = "fiveDays";
          } else if (fourthSame.length > 0) {
            mode = "fourDays";
          } else if (thirdSame.length > 0) {
            mode = "threeDays";
          } else if (secondSame.length > 0) {
            mode = "twoDays";
          } else {
            mode = "allSame";
          }
          newObj["name"] = t("valid_from_") + " " + moment(oP.valid_from).format("DD.MM.YY");
          switch (mode) {
            case "allSame":
              if (same.length === 5) {
                newObj["name"] +=
                  ", " +
                  t("in_weekdays") +
                  ": " +
                  same[0].begin.substring(0, 5) +
                  " - " +
                  same[0].end.substring(0, 5);
              } else if (same.length === 7) {
                newObj["name"] +=
                  ", " +
                  t("everyday") +
                  ": " +
                  same[0].begin.substring(0, 5) +
                  " - " +
                  same[0].end.substring(0, 5);
              } else {
                let nameString = "";
                same.map((s) => {
                  if (nameString.length < 1) {
                    nameString = t(day[s.weekday]);
                  } else {
                    nameString += ", " + t(day[s.weekday]);
                  }
                });
                newObj["name"] +=
                  ", " +
                  nameString +
                  ": " +
                  same[0].begin.substring(0, 5) +
                  " - " +
                  same[0].end.substring(0, 5);
              }
              break;
            case "twoDays":
              if (same.length === 5 && secondSame.length === 2) {
                newObj["name"] +=
                  ", " +
                  t("weekdays") +
                  ": " +
                  same[0].begin.substring(0, 5) +
                  " - " +
                  same[0].end.substring(0, 5) +
                  ", " +
                  t("weekend") +
                  ": " +
                  secondSame[0].begin.substring(0, 5) +
                  " - " +
                  secondSame[0].end.substring(0, 5);
              } else {
                let nameString = "",
                  nameString2 = "";
                same.map((s) => {
                  if (nameString.length < 1) {
                    nameString = t(day[s.weekday]);
                  } else {
                    nameString += ", " + t(day[s.weekday]);
                  }
                });
                secondSame.map((s) => {
                  if (nameString2.length < 1) {
                    nameString2 = t(day[s.weekday]);
                  } else {
                    nameString2 += ", " + t(day[s.weekday]);
                  }
                });
                newObj["name"] +=
                  ", " +
                  nameString +
                  ": " +
                  same[0].begin.substring(0, 5) +
                  " - " +
                  same[0].end.substring(0, 5) +
                  ", " +
                  nameString2 +
                  ": " +
                  secondSame[0].begin.substring(0, 5) +
                  " - " +
                  secondSame[0].end.substring(0, 5) +
                  " ";
              }
              break;
            default:
              same.map((s) => {
                if (typeof newObj["name"] !== "undefined" && newObj["name"].length < 1) {
                  newObj["name"] = t(day[s.weekday]);
                } else {
                  newObj["name"] += ", " + t(day[s.weekday]);
                }
              });
              newObj["name"] +=
                ": " + same[0].begin.substring(0, 5) + " - " + same[0].end.substring(0, 5);
              secondSame.map((s) => {
                newObj["name"] += ", " + t(day[s.weekday]);
              });
              newObj["name"] +=
                ": " +
                secondSame[0].begin.substring(0, 5) +
                " - " +
                secondSame[0].end.substring(0, 5);
              thirdSame.map((s) => {
                newObj["name"] += ", " + t(day[s.weekday]);
              });
              newObj["name"] +=
                ": " +
                thirdSame[0].begin.substring(0, 5) +
                " - " +
                thirdSame[0].end.substring(0, 5);
              if (fourthSame.length > 0) {
                fourthSame.map((s) => {
                  newObj["name"] += ", " + t(day[s.weekday]);
                });
                newObj["name"] +=
                  ": " +
                  fourthSame[0].begin.substring(0, 5) +
                  " - " +
                  fourthSame[0].end.substring(0, 5);
              }
              if (fifthSame.length > 0) {
                fifthSame.map((s) => {
                  newObj["name"] += ", " + t(day[s.weekday]);
                });
                newObj["name"] +=
                  ": " +
                  fifthSame[0].begin.substring(0, 5) +
                  " - " +
                  fifthSame[0].end.substring(0, 5);
              }
              if (sixthSame.length > 0) {
                sixthSame.map((s) => {
                  newObj["name"] += ", " + t(day[s.weekday]);
                });
                newObj["name"] +=
                  ": " +
                  sixthSame[0].begin.substring(0, 5) +
                  " - " +
                  sixthSame[0].end.substring(0, 5);
              }
              if (seventhSame.length > 0) {
                seventhSame.map((s) => {
                  newObj["name"] += ", " + t(day[s.weekday]);
                });
                newObj["name"] +=
                  ": " +
                  seventhSame[0].begin.substring(0, 5) +
                  " - " +
                  seventhSame[0].end.substring(0, 5);
              }
          }
        } else {
          newObj["name"] = t("no times");
        }
        objects.push(newObj);
      });
      setOpeningPeriodsSelects(objects);
    }
  };

  const paymentMethods = [
    { id: "paypalAgreement", name: t("paypal") },
    { id: "stripeSISDKCC", name: t("credit_card") },
    { id: "stripeSepa", name: t("sepa") },
    { id: "applePay", name: t("ApplePay") },
    { id: "googlePay", name: t("GooglePay") },
    { id: "cartVoucher", name: t("cart_voucher") },
    { id: "cartItemVoucher", name: t("cart_item_voucher") },
  ];

  const [selectedItems, setSelectedItems] = useState(function () {
    let sel = [];
    if (pricetariff.payment_methods !== null) {
      let t = pricetariff.payment_methods.split(",");
      let pMethods = {};
      paymentMethods.map((p) => {
        pMethods[p.id] = p.name;
      });
      console.log(pMethods);
      if (t.length > 0) {
        t.map((st) => {
          sel.push({ id: st, name: pMethods[st] });
        });
      }
    }
    console.log(sel, "sel");
    return sel;
  });

  const onChange = (result, type) => {
    let fields = [];
    result.result.map((field) => {
      fields.push(field.id);
    });
    let payment_methods = fields.length > 0 ? fields.join(",") : null;
    let clone = {};
    Object.assign(clone, pricetariff);
    clone.payment_methods = payment_methods;
    setPricetariff(clone);
  };
  const triggerOnChange = () => {
    onChange({ result: selectedItems }, "payment_methods");
  };
  const _initialize = () => {
    if (openingPeriodsPending) return;
    if (typeof pricetariff.id !== "undefined") {
      props.dispatch(
        checkInPeriodsActions.getCheckInPeriods({
          token: Biscuit.get("token"),
          filter: {
            pricetariff_id: pricetariff.id,
          },
        })
      );
      setOpeningPeriodsPending(true);
    }

    if (
      props.pricetariffValidFromStatus === "none" &&
      props.pricetariffStatus !== "add" &&
      prices === null
    ) {
      let et_value = {};
      pricetariff.pricetariff_valid_froms.forEach(function (val, k) {
        if (val.id === pricetariff.actual_valid_from_id) {
          et_value = val;
          setPrices(val.prices);
        }
      });
      setTimeout(() => {
        setTimespan({
          begin_date: new Date(moment(et_value.valid_from).format("YYYY-MM-DD")),
        });
      }, 100);

      setTimeout(() => {
        setPrices(et_value.prices);
      }, 100);

      setTimeout(() => {
        setValidFrom(et_value);
      }, 100);
    } else {
      if (!openingPeriodsPending) {
        if (_openingPeriods.success !== "") {
          if (openingPeriodsSelects.length > 0 && pricetariff.check_in_periods.length > 0) {
            let selected = [];
            pricetariff.check_in_periods.map((cP) => {
              openingPeriodsSelects.map((oPs) => {
                if (oPs.id === cP.id) {
                  selected.push({ label: oPs.name, value: oPs.id });
                }
              });
            });
            setSelectedOpeningPeriods(selected);
          }
        }
        if (typeof pricetariffValidFrom.id !== "undefined") {
          setPrices(pricetariffValidFrom.prices);
        }
        let contingentProductsArray = [];
        if (typeof pricetariffValidFrom.id !== "undefined") {
          setPrices(props.pricetariffValidFrom.prices);
          let clone3 = {};
          Object.assign(clone3, pricetariffValidFrom);
          clone3.pricesToPush = [];
          setValidFrom(clone3);
        }
        let productValues = [];
        let newProducts = [];
        props.products[153].forEach(function (value, key) {
          contingentProductsArray.push(value.id);
          if (props.productId !== null) {
            if (Number(props.productId) === value.id) {
              let _helper = new Array();
              _helper["value"] = value.id;
              _helper["label"] = value.name;
              productValues.push(_helper);
              setContingentProduct(true);
            }
          }
          if (typeof pricetariff.products !== "undefined") {
            pricetariff.products.forEach(function (prod, k) {
              if (prod.id === value.id) {
                let _helper = new Array();
                _helper["value"] = value.id;
                _helper["label"] = value.name;
                productValues.push(_helper);
                setContingentProduct(true);
              }
            });
          }
          newProducts.push(value);
        });
        setContingentProducts(contingentProductsArray);
        props.products[154].forEach(function (value, key) {
          if (value.client_id !== null) {
            if (props.productId !== null) {
              if (Number(props.productId) === value.id) {
                let _helper = { value: value.id, label: value.name };
                productValues.push(_helper);
              }
            }
            if (typeof pricetariff.products !== "undefined") {
              pricetariff.products.forEach(function (prod, k) {
                if (prod.id === value.id) {
                  let _helper = { value: value.id, label: value.name };
                  productValues.push(_helper);
                }
              });
            }
            newProducts.push(value);
          }
        });

        setSelectedProducts(productValues);
        let clone = {};
        let clone2 = {};
        Object.assign(clone, pricetariff);
        Object.assign(clone2, availProducts);
        clone.productsForSelect = productValues;
        clone.products = productValues;
        clone.pricesToPush = [];
        if (typeof clone.extension_possible === "undefined") {
          clone.extension_possible = "WithoutTaskAndPayment";
        }
        if (clone.duration !== null && clone.duration !== "") {
          if (clone.duration >= 86400) {
            clone._rate = 86400;
          } else if (clone.duration >= 3600) {
            clone._rate = 3600;
          } else if (clone.duration >= 60) {
            clone._rate = 60;
          }
          clone._amount = clone.duration / clone._rate;
        } else {
          clone._rate = 60;
        }
        clone2.products = newProducts;
        setAvailProducts(clone2);
        setPricetariff(clone);
      }
    }
    setInitializeState(true);
  };

  if (!initialized) {
    _initialize();
  }

  const addCheckinPeriod = (e) => {
    setShowAddCheckInPeriodDialog(true);
  };

  const inArray = (needle, haystack) => {
    let length = haystack.length;
    for (let i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
    return false;
  };

  const deletePrice = (price) => {
    let filteredPrices = pricetariffValidFrom.pricesToPush.filter(
      (item) => item._uid !== price._uid
    );
    setValidFrom({
      ...pricetariffValidFrom,
      pricesToPush: filteredPrices,
    });
    setPrices(filteredPrices);
    /* let prices = [...pricetariffValidFrom.prices];
        let pricesToPush = [...pricetariffValidFrom.pricesToPush];
        let newPricesA=[], newPricesB = [];
        prices.forEach(function(val,index){
            if(typeof val.id !== 'undefined'){
                if(val.id !== id){
                    newPricesA.push(val);
                }
            } else {
                newPricesA.push(val);
            }
        });
        pricesToPush.forEach(function(val,index){
            if(typeof val.id !== 'undefined'){
                if(val.id !== id){
                    newPricesB.push(val);
                }
            } else {
                newPricesB.push(val);
            }
        });
        setValidFrom({
            ...pricetariffValidFrom,
            prices: newPricesA,
            pricesToPush: newPricesB
        });
        setPrices(newPricesA);*/
  };

  const addPrice = (prices) => {
    setValidFrom({
      ...pricetariffValidFrom,
      pricesToPush: prices,
    });
    setPrices(prices);
    // let pricesToPush = [...pricetariffValidFrom.pricesToPush];

    /* let prices = [...pricetariffValidFrom.prices];
        let pricesToPush = [...pricetariffValidFrom.pricesToPush];
        if(content.amount === ""){
            content.amount = null;
        }
        if(content.percent_from_uvp === ""){
            content.percent_from_uvp = null;
        } else {
            content.percent_from_uvp = Number(content.percent_from_uvp);
        }

        prices.push({
                    id: content.id,
                    amount:content.amount,
                    percent_from_uvp:content.percent_from_uvp,
                    pricetype_id:content.pricetype_id,
                    created: moment().format('YYYY-MM-DD HH:mm:ss'),
                    pricetariff_valid_from_id: pricetariffValidFrom.id
                });
            pricesToPush.push({
                id: content.id,
                amount:content.amount,
                percent_from_uvp:content.percent_from_uvp,
                pricetype_id:content.pricetype_id,
                created: moment().format('YYYY-MM-DD HH:mm:ss'),
                pricetariff_valie_from_id: pricetariffValidFrom.id
            });

                setValidFrom({
                    ...pricetariffValidFrom,
                    prices: prices,
                    pricesToPush: pricesToPush
                });


        setPrices(prices);*/
  };

  const onAddPriceClicked = (e) => {
    setPrices(null);
    let newPrice = {
      amount: "",
    };

    if (prices === null) {
      setPrices([newPrice]);
    } else {
      console.log(prices);
      let clone = prices;
      clone.push(newPrice);
      setPrices(clone);
    }
  };

  // evaluate form and send pricetariff to api
  const onSubmit = () => {
    if (pricetariff.name === "") {
      // show notification, mark field as required
      setNotification({
        message: 'Das Feld "Bezeichnung" darf nicht leer sein!',
        show: true,
      });
      return;
    }
    let clone = {};
    Object.assign(clone, pricetariff);

    let clone1 = {};
    Object.assign(clone1, pricetariffValidFrom);
   /* clone1.valid_from = _getFormattedTime(timespan.begin_date);*/
    let error = false;
    console.log(clone1);
    clone1.pricesToPush.map((price) => {
      if (price.amount === "" || price.pricetype_id === 0) {
        error = true;
        $("#" + price._uid).css("borderColor", "red");
      }
    });
    if (error) {
      props.dispatch(
        alertsActions.addAlert({
          message: t("form_validation_error"),
          icon: "fi fi-alert",
        })
      );
    } else {
      clone1.prices = clone1.pricesToPush;
      delete clone1.pricesToPush;
      delete clone.pricesToPush;
      clone.pricetariff_valid_froms = [clone1];
      if (clone._rate !== "" && clone._amount !== "" && clone._rate > 0) {
        clone.duration = clone._rate * clone._amount;
      }
      let _products = [];
      let _setted = [];
      clone.productsForSelect.forEach(function (value, key) {
        if (typeof value.label !== "undefined" && typeof value.value !== "undefined") {
          if (!inArray(value.value, _setted)) {
            _products.push({ id: value.value });
            _setted.push(value.value);
          }
        } else {
          if (!inArray(value.id, _setted)) {
            _products.push({ id: value.id });
            _setted.push(value.id);
          }
        }
      });
      delete clone.productsForSelect;
      clone.products = _products;
      if (typeof clone.check_in_periods_to_save !== "undefined") {
        if (clone.check_in_periods_to_save.length > 0) {
          clone.check_in_periods_to_save.map((cp) => {
            props.dispatch(
              checkInPeriodsActions.editCheckInPeriod({
                token: Biscuit.get("token"),
                id: cp.id,
                body: cp,
              })
            );
          });
          delete clone.check_in_periods;
          delete clone.check_in_periods_to_save;
        } else {
          delete clone.check_in_periods_to_save;
          if (clone.check_in_periods.length > 0) {
            clone.check_in_periods.map((cP) => {
              props.dispatch(
                checkInPeriodsActions.deleteCheckInPeriod({
                  token: Biscuit.get("token"),
                  id: cP.id,
                })
              );
            });
          }
          delete clone.check_in_periods;
        }
      }

      const callback = (response) => {
        if (response.success) {
          if (typeof pricetariff.id !== "undefined" && pricetariff.id !== null) {
            props.dispatch(
              alertsActions.addAlert({
                message: t("updated_${a}", { a: t("pricetariff") }, "capital"),
                icon: "fi fi-check",
              })
            );
          } else {
            props.dispatch(
              alertsActions.addAlert({
                message: t("added_${a}", { a: t("pricetariff") }, "capital"),
                icon: "fi fi-check",
              })
            );
            let link =
              "/pricetariffs/" +
              response.data.id +
              "/validFrom/" +
              response.data.pricetariff_valid_froms[0].id;
            $("#resetLink").attr("href", link);
            $("#resetLink").click();
          }
        } else {
          props.dispatch(
            alertsActions.addAlert({
              message: t("request_error"),
              icon: "fi fi-alert",
            })
          );
        }
      };

      if (typeof pricetariff.id !== "undefined" && pricetariff.id !== null) {
        props.dispatch(
          priceTariffsActions.patchPricetariff({
            id: Number(pricetariff.id),
            data: {
              ...clone,
            },
            callback,
            token: Biscuit.get("token"),
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          })
        );
      } else {
        props.dispatch(
          priceTariffsActions.addPricetariff({
            data: {
              ...clone,
            },
            callback,
            token: Biscuit.get("token"),
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          })
        );
      }
      setPricetariffPending(true);
      setItemState("saving");
    }
  };

  const close = (withReRender = false) => {
    props.onClose();

    /* setContingents(null);
        const callback = (response) => {
            if (response.success) {
                setContingents(response.data);
            }
        };
        props.dispatch(contingentsActions.getContingents({
            callback,
            filter: {
                'findForSelect': true,
            },
            token: Biscuit.get('token')
        }));
        setLocations(null);
        props.onClose();*/
  };

  const onChangeForm = (e) => {
    let clone = {};
    setPricetariffChanged(true);
    Object.assign(clone, pricetariff);
    switch (e.target.name) {
      case "name":
        clone.name = e.target.value;
        break;
      case "description":
        clone.description = e.target.value;
        break;
      case "short_description":
        clone.short_description = e.target.value;
        break;
      case "_rate":
        clone._rate = e.target.value;
        break;
      case "_amount":
        if (e.target.value === null || e.target.value === "") {
          e.target.value = 0;
        }
        clone._amount = e.target.value;
        break;
      case "default_tariff":
        clone.default_tariff = e.target.checked;
        break;
      case "only_discount_first_unit":
        clone.only_discount_first_unit = e.target.checked;
        break;
      case "types":
        clone.types = e.target.value === "null" ? null : e.target.value;
        break;
      case "amount_cost_free_contingents":
        clone.amount_cost_free_contingents = e.target.value === null ? 0 : e.target.value;
        break;
    }
    setPricetariff(clone); // set object state*/
  };

  const onChangeBeginDate = (value) => {
    if (value != "") {
      setTimespan({
        ...timespan,
        begin_date: value,
      });
      let clone = {};
      Object.assign(clone, pricetariffValidFrom);
      clone.valid_from = _getFormattedTime(value);
      setValidFrom(clone);
    }
  };

  const onChangeBegin = (e, field) => {
    const clone = {};
    Object.assign(clone,pricetariffValidFrom);
    let date,time;
    if(field !== null){
      date = moment(clone.valid_from).format('YYYY-MM-DD');
      time = e.target.value;
      clone.valid_from = moment(date+' '+time).format('YYYY-MM-DD HH:mm:00');
    } else {
      date = moment(e).format('YYYY-MM-DD');
      time = moment(clone.valid_from).format('HH:mm:00');
      clone.valid_from = moment(date+' '+time).format('YYYY-MM-DD HH:mm:00');
    }
    setValidFrom(clone);
  };

  const onChangeProducts = (product) => {
    setContingentProduct(false);
    if (product === null) {
      setPricetariff({
        ...pricetariff,
        products: [],
        productsForSelect: [],
      });
      return;
    }

    let products = [...pricetariff.products];
    product.forEach(function (val, k) {
      products.push({
        id: val.value,
      });
      if (inArray(val.value, contingentProducts)) {
        setContingentProduct(true);
      }
    });

    setPricetariff({
      ...pricetariff,
      products: products,
      productsForSelect: product,
    });
  };

  const onCExtensionPossible = (e) => {
    let vars = {
      donothing: "WithoutTaskAndPayment",
      task: "WithTask",
      extend_charge: "WithPayment",
      open_charge: "WithPayment",
      open_authorize: "WithPayment",
    };
    setPricetariffChanged(true);
    setExtension(e.target.value);
    setPricetariff({
      ...pricetariff,
      extension: e.target.value,
      extension_possible: vars[e.target.value],
    });
  };

  const _getFormattedTime = (date) => {
    var total = moment(new Date(date)).format("YYYY-MM-DD");
    total += " 00:00:00";
    return total;
  };

  let _helper = [],
    extension_helper = [],
    types = [];
  const [extension, setExtension] = useState(
    pricetariff.extension === "" || pricetariff.extension === null
      ? "donothing"
      : pricetariff.extension
  );

  const onChangeOpeningPeriods = (period) => {
    setSelectedOpeningPeriods(period);
    if (period === null) {
      setPricetariff({
        ...pricetariff,
        check_in_periods_to_save: [],
      });
      setSelectedOpeningPeriods([]);
      return;
    }
    let periods = [...pricetariff.check_in_periods];
    period.forEach(function (val, k) {
      _openingPeriods.data.map((oP) => {
        if (oP.id === val.value) {
          oP.pricetariff_id = pricetariff.id;
          periods.push(oP);
        }
      });
    });

    setPricetariff({
      ...pricetariff,
      check_in_periods_to_save: periods,
    });
  };

  const abortButtonRef = React.createRef();
  const resetButtonRef = React.createRef();

  let link = "/pricetariffs";
  if (props.productId !== null) {
    link = "/products/" + props.productId;
  }

  const extensions = {
    donothing: t("Extension possible", null, "capital"),
    task: t("Task for manager", null, "capital"),
    extend_charge: t(""),
  };

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>
      <div
        className="off-canvas position-right is-transition-overlap is-open "
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        data-close-on-click="false"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {typeof pricetariff.id !== "undefined" && pricetariff.id !== null
              ? t("edit_${a}", { a: t("pricetariff", null, "capital") })
              : t("add_${a}", { a: t("pricetariff", null, "capital") })}
          </h1>
          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title="Speichern"
              onClick={onSubmit}
            >
              {itemState == "init" && (
                <>
                  <i className="fi fi-check"></i>
                  <span>{t("save")}</span>
                </>
              )}
              {itemState == "saving" && (
                <span>
                  <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                  {t("save")}
                </span>
              )}
            </button>
            <a href={link}>
              <button
                type="button"
                ref={abortButtonRef}
                id="inb-pricetariffsform-abort-button"
                className="button hollow secondary right button-abort round"
                title="Fenster schließen"
                onClick={close}
              >
                <i className="fi fi-x"></i>
              </button>
            </a>
            <a id="resetLink" href={link} style={{ display: "none" }}>
              <button
                type="button"
                ref={resetButtonRef}
                id="inb-pricetariffsform-reset-button"
                className="button hollow secondary right button-abort round"
                title="Fenster schließen"
              >
                <i className="fi fi-x"></i>
              </button>
            </a>
          </div>
        </header>

        <form id="pricetariffValidFrom" className="off-content row">
          <div className="inb-form-group column medium-6 small-12 name">
            <label className="inb-form__controlLabel">{t("name")}</label>
            <div className="inb-form__controllClass">
              <input
                id="pricetariff_item_input_name"
                type="text"
                className="form-control"
                name="name"
                required=""
                autoComplete="false"
                placeholder=""
                value={pricetariff.name}
                onChange={onChangeForm}
              />
            </div>
          </div>

          <div className="inb-form-group column medium-6 small-12 description">
            <label className="inb-form__controlLabel">{t("description")}</label>
            <div className="inb-form__controllClass">
              <textarea
                id="pricetariff_item_input_description"
                className="form-control"
                name="description"
                required=""
                autoComplete="false"
                placeholder=""
                value={pricetariff.description}
                onChange={onChangeForm}
              />
            </div>
          </div>
          {Biscuit.get("client.show_usage_types") === "true" && (
            <>
              <div className="inb-form-group column medium-6 small-12 description">
                <label className="inb-form__controlLabel">{t("types")}</label>
                <div className="inb-form__controllClass">
                  <select onChange={onChangeForm} value={pricetariff.types} name="types">
                    {[
                      { key: "null", value: t("all rides") },
                      { key: "booking", value: t("booking") },
                      {
                        key: "official",
                        value: t("official"),
                      },
                      { key: "service", value: t("service") },
                    ].map((type) => {
                      return <option value={type.key}>{type.value}</option>;
                    })}
                  </select>
                </div>
              </div>
              {typeof pricetariff.id !== "undefined" && pricetariff.types !== null && (
                <>
                  <div className="inb-form-group column medium-12 small-12 lang">
                    <label className="inb-form__controlLabel">
                      {t("valid times", null, "capital")}
                    </label>
                    <div className="inb-form__controllClass">
                      <Select
                        className="form-control"
                        name="times"
                        value={selectedOpeningPeriods}
                        onChange={onChangeOpeningPeriods}
                        isMulti="true"
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: "3px",
                          colors: {
                            ...theme.colors,
                            primary25: "#EB6A3A",
                            primary: "#EB6A3A",
                          },
                        })}
                        placeholder={t("select_${a}", { a: t("valid time") })}
                        options={openingPeriodsSelects.map((oP) => {
                          return { value: oP.id, label: oP.name };
                        })}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          <div className="inb-form-group column medium-6 small-12 description">
            <label className="inb-form__controlLabel">{t("short_description")}</label>
            <div className="inb-form__controllClass">
              <textarea
                id="pricetariff_item_input_description"
                className="form-control"
                name="short_description"
                required=""
                autoComplete="false"
                placeholder=""
                value={pricetariff.short_description}
                onChange={onChangeForm}
                maxLength="32"
              />
            </div>
          </div>

          <div className="inb-form-group column medium-12 small-12 lang">
            <label className="inb-form__controlLabel">{t("products", null, "capital")}</label>
            <div className="inb-form__controllClass">
              <Select
                className="form-control"
                name="products"
                value={pricetariff.productsForSelect}
                onChange={onChangeProducts}
                isMulti="true"
                theme={(theme) => ({
                  ...theme,
                  borderRadius: "3px",
                  colors: {
                    ...theme.colors,
                    primary25: "#EB6A3A",
                    primary: "#EB6A3A",
                  },
                })}
                placeholder={t("select_${a}", { a: t("product") })}
                options={availProducts.products.map((product) => {
                  return { value: product.id, label: product.name };
                })}
              />
            </div>
          </div>

          {contingentProduct && (
            <>
              <hr className="row medium-12 small-12" style={{ marginTop: "20px" }} />
              <br />
              <span className="row medium-12 small-12 inb-list-title inb-form-group">
                {t("reservations", null, "capital")}
              </span>

              <div className="inb-form-group column medium-3 small-6">
                <label className="inb-form__controlLabel">{t("duration", null, "capital")}</label>
              </div>

              <div className="inb-form-group column medium-9 small-12">
                <label className="inb-form__controlLabel">
                  {t("reservation_overdraft", null, "capital")}
                </label>
              </div>
              <div className="inb-form-group column medium-1 small-2 _amount">
                <div className="inb-form__controllClass">
                  <input
                    type="text"
                    className="form-control"
                    name="_amount"
                    value={pricetariff._amount}
                    placeholder=""
                    onChange={(e) => onChangeForm(e)}
                  />
                </div>
              </div>

              <div className="inb-form-group column medium-2 small-4 _rate">
                <div className="inb-form__controllClass">
                  <select
                    className="form-control "
                    name="_rate"
                    value={pricetariff._rate}
                    onChange={(e) => onChangeForm(e)}
                  >
                    {/*<option value="0">{ " " }</option>*/}
                    <option value="60">{t("minutes", null, "capital")}</option>
                    <option value="3600">{t("hours", null, "capital")}</option>
                    <option value="86400">{t("days", null, "capital")}</option>
                  </select>
                </div>
              </div>

              <div className="inb-form-group column medium-5 small-12_rate">
                <select
                  className="form-control"
                  name="extension"
                  value={extension}
                  onChange={(e) => onCExtensionPossible(e)}
                >
                  <option value="donothing">{t("overdraft_possible", null, "capital")}</option>
                  <option value="task">{t("add_task_for_manager", null, "capital")}</option>
                  <option value="extend_charge">
                    {t("extend_tariff_automatically", null, "capital")}
                  </option>
                  <option value="extend_charge_with_task">
                    {t("extend_tariff_automatically_with_task", null, "capital")}
                  </option>
                  <option value="open_charge">{t("Open end with Payment", null, "capital")}</option>
                  <option value="open_authorize">
                    {t("Open end with pay authorization", null, "capital")}
                  </option>
                </select>
              </div>
              <div className="inb-form__controllClass column medium-3 small-6">
                <input
                  id="default"
                  type="checkbox"
                  name="default_tariff"
                  checked={pricetariff.default_tariff}
                  onChange={(e) => onChangeForm(e)}
                />
                <label htmlFor="default"> {t("default_tariff", null, "capital")}</label>
              </div>
              <div className="inb-form__controllClass column medium-3 small-6">
                <input
                  id="default"
                  type="checkbox"
                  name="only_discount_first_unit"
                  checked={pricetariff.only_discount_first_unit}
                  onChange={(e) => onChangeForm(e)}
                />
                <label htmlFor="default"> {t("only discount first unit", null, "capital")}</label>
              </div>
              {Biscuit.get("client.show_usage_types") === "true" && (
                <>
                  {" "}
                  <div className="inb-form__controllClass column medium-3 small-6">
                    <label htmlFor="default">
                      {" "}
                      {t("amount_cost_free_contingents", null, "capital")}{" "}
                      <i className="fi fi-info" title={t("amount_cost_free_contingents_info")}>
                        {" "}
                      </i>
                    </label>
                    <input
                      id="default"
                      type="number"
                      name="amount_cost_free_contingents"
                      value={
                        pricetariff.amount_cost_free_contingents === null
                          ? 0
                          : pricetariff.amount_cost_free_contingents
                      }
                      onChange={(e) => onChangeForm(e)}
                      style={{ maxWidth: "70px" }}
                    />
                  </div>
                </>
              )}
              {/*  <div className="inb-form__controllClass">
                        <input type="radio" className="form-control"  id ="radio1" name="extension_possible"
                               value="WithoutTaskAndPayment"  checked={pricetariff.extension_possible === "WithoutTaskAndPayment"} placeholder="" onChange={(e) => onCExtensionPossible(e)}/>
                        <label htmlFor="radio1"> {t('overdraft_possible', null, 'capital')}</label>
                    </div>
                </div>

                <div className="inb-form-group column medium-2 small-6_rate">
                    <div className="inb-form__controllClass">
                        <input type="radio" className="form-control"  id ="radio2" name="extension_possible"
                               value="WithTask" checked={pricetariff.extension_possible === "WithTask"} placeholder="" onChange={(e) => onCExtensionPossible(e)}/>
                        <label htmlFor="radio2"> {t('add_task_for_manager', null, 'capital')}</label>
                    </div>
                </div>

                <div className="inb-form-group column medium-4 small-8_rate">
                    <div className="inb-form__controllClass">
                        <input type="radio" className="form-control"  id ="radio3" name="extension_possible"
                               value="WithPayment"  checked={pricetariff.extension_possible === "WithPayment"} placeholder="" onChange={(e) => onCExtensionPossible(e)}/>
                        <label htmlFor="radio3" > {t('extend_tariff_automatically', null, 'capital')}</label>

                    </div>
                </div>
*/}
            </>
          )}
          <hr className="row medium-12 small-12" style={{ marginTop: "20px" }} />
          <br />
          <div
            className="row medium-2 small-4"
            style={{ float: "left", maxWidth: "14%", paddingTop: "11px" }}
          >
            <span className="inb-list-title inb-form-group">{t("prices valid from")}</span>
          </div>
          <div
            className="inb-form-group column medium-2 small-6 description"
            style={{ marginLeft: "-10px", paddingTop: "1px" }}
          >
            <DatePicker
                className="noBorders-noBackground"
                dateFormat="dd.MM.y"
                selected={timespan.begin_date}
                onChange={(date) => onChangeBegin(date)}
                onKeyDown={(e) => {
                  if (e.keyCode === 8) e.preventDefault();
                }}
                placeholderText=""
                locale={de}
            />
            <input
                className="input-group-field"
                type="time"
                name="valid_from_time_field"
                disabled={''}
                value={moment(timespan.begin_date).format('HH:mm') }
                style={{float: "left"}}
                onChange={(e)=>{onChangeBegin(e,"valid_from_time_field")}}
            />
          </div>

          <br />

          <div className="row medium-12 small-12">
            <FormItem
              type="multiSelect"
              value={
                pricetariff.payment_methods !== null ? pricetariff.payment_methods.split(",") : null
              }
              id={typeof pricetariff.id !== "undefined" ? pricetariff.id : "new"}
              name="payment_methods"
              label={
                t("payment settings") +
                " (" +
                t("leave it empty for standard payment methods") +
                ")"
              }
              labelStyle={{
                minWidth: "120px",
                float: "left",
                marginLeft: "15px",
              }}
              selectStyle={{ width: "50%" }}
              data={paymentMethods}
              placeholder={t("leave it empty for standard payment methods")}
              valkey="id"
              valprop="name"
              mediumWidth="12"
              smallWidth="12"
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
              triggerOnChange={triggerOnChange}
            />
          </div>
          <br />

          <PricesList
            pricetypes={props.pricetypes}
            onSave={onSubmit}
            pricesOrigin={prices}
            pricetariff={props.pricetariff}
            pricetariffValidFrom={pricetariffValidFrom}
            onAddPriceClicked={onAddPriceClicked}
            addPriceOrigin={addPrice}
            deletePriceOrigin={deletePrice}
            dispatch={props.dispatch}
          >
            {" "}
          </PricesList>
        </form>
      </div>
    </>
  );
};

export default SubItemView;
